/* eslint-disable */
import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Px } from '../assets/posize';

import '../assets/styles/class.scss';

import { pages } from '../global/constants';
import HeaderWhite from '../components/HeaderWhite.jsx';
import Indexes from '../components/Indexes';
import Volume from 'components/Volume';

@observer
class HomeView extends React.Component {
  componentDidMount() {
    this.props.getMuted();
  }

  render() {
    const { isMuted, setMuted } = this.props;

    return (
      <div
        style={{
          '--src': `url(${
            require('assets/2474eb2dbf3a5db79699e6f9255b4b4b.png').default
          })`
        }}
        className={`home position ${css(styles.group, styles.group_layout)}`}
      >
        <div className={css(styles.flex, styles.flex_layout1)}>
          <div className={css(styles.group1, styles.group1_layout)}>
            <div className={css(styles.group2, styles.group2_layout)}>
              <div className={css(styles.component, styles.component_layout)}>
                <HeaderWhite />
              </div>
            </div>
          </div>

          <div className={css(styles.flex_item)}>
            <div className={css(styles.flex1, styles.flex1_layout)}>
              <div className={css(styles.flex_spacer)} />
              <div className={css(styles.flex_item1)}>
                <div
                  className={`position ${css(styles.flex, styles.flex_layout)}`}
                >
                  <div className={css(styles.flex_spacer1)} />
                  <h1
                    className={css(
                      styles.hero_title_box,
                      styles.hero_title_box_layout
                    )}
                  >
                    <pre className={css(styles.hero_title)}>
                      {'你的五感靈魂\n是什麼風味樣貌？'}
                    </pre>
                  </h1>
                  <div className={css(styles.flex_spacer2)} />
                  <h5
                    className={css(
                      styles.highlights_box,
                      styles.highlights_box_layout
                    )}
                  >
                    <pre className={css(styles.highlights)}>
                      {
                        '生活中所有的聲音氣味和感受，你已經習慣與之共處了嗎？\n透過10個問題，放大你的感官知覺。我們來一探究竟，五感靈魂的樣貌。答案結尾會推薦你一款適合你的紅烏龍茶！\n\n*建議開啟裝置聲音，全然體驗五感。'
                      }
                    </pre>
                  </h5>
                  <div className={css(styles.flex_item2)}>
                    <Px
                      onClick={() => window.open('/questions', '_self')}
                      x="1px 160fr 406fr"
                      y="24px minmax(44px,44fr) 16px"
                      altClassName={`cursor-pointer`}
                      className={css(styles.group3)}
                      xxxlX="0px 160fr 406fr"
                      xxxlY="24px minmax(44px,44fr) 0px"
                      mdX="0px 160fr 406fr"
                      mdY="24px minmax(44px,44fr) 0px"
                      xsX="0px 160fr 0fr"
                      xsY="24px minmax(44px,44fr) 0px"
                    >
                      <h5
                        className={css(
                          styles.highlights1,
                          styles.highlights1_layout
                        )}
                      >
                        {'開始探索吧！'}
                      </h5>
                    </Px>
                  </div>

                  <div className={css(styles.group4, styles.group4_layout)}>
                    <div className={css(styles.flex2, styles.flex2_layout)}>
                      <div className={css(styles.flex_item3)}>
                        <div
                          style={{
                            '--src': `url(${
                              require('assets/e968298178d674fbf0ed44b06fc5051f.png')
                                .default
                            })`
                          }}
                          className={css(styles.icon, styles.icon_layout)}
                        />
                      </div>
                      <div className={css(styles.flex_spacer3)} />
                      <div className={css(styles.flex_item4)}>
                        <h5
                          className={css(
                            styles.highlights2_box,
                            styles.highlights2_box_layout
                          )}
                        >
                          <pre className={css(styles.highlights2)}>
                            {'請使用手機掃描QR Code\n以獲得最佳瀏覽體驗'}
                          </pre>
                        </h5>
                      </div>
                      <div className={css(styles.flex_spacer4)} />
                    </div>
                  </div>

                  <div className={css(styles.flex_spacer5)} />

                  <div className={css(styles.group5, styles.group5_layout)}>
                    <div className={css(styles.group6, styles.group6_layout)}>
                      <div
                        className={css(
                          styles.component,
                          styles.component_layout1
                        )}
                      >
                        <Indexes type="home" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={css(styles.flex_spacer6)} />

          <div className={css(styles.group7, styles.group7_layout)}>
            <div className={css(styles.component, styles.component_layout2)}>
              <Volume isMuted={isMuted} setMuted={setMuted} />
            </div>
          </div>

          <div className={css(styles.flex_spacer7)} />
          <div className={css(styles.text_body, styles.text_body_layout)}>
            {'Designed by Irori Design 版權所有 © 2021 女兒不懂茶'}
          </div>
        </div>
      </div>
    );
  }
}

HomeView.inStorybook = true;

export default withRouter(HomeView);

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    backgroundColor: 'rgb(255,255,255)',
    borderRadius: '0px 0px 0px 0px'
  },
  group_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: 0
  },
  flex: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex_layout1: {
    position: 'relative',
    flexGrow: 1,
    margin: '5px 139px',
    '@media (max-width: 1199.98px)': {
      margin: '5px 70px'
    },
    '@media (max-width: 991.98px)': {
      margin: '5px 35px'
    },
    '@media (max-width: 767.98px)': {
      margin: '5px 18px'
    },
    '@media (max-width: 575.98px)': {
      margin: '5px 10px'
    }
  },
  group1: {
    display: 'flex'
  },
  group1_layout: {
    position: 'relative',
    flex: '0 0 auto'
  },
  group2: {
    display: 'flex'
  },
  group2_layout: {
    position: 'relative',
    flexGrow: 1
  },
  component: {},
  component_layout: {
    height: 39,
    flexGrow: 1,
    margin: '12px 1.5px 0px 0px'
  },
  flex_item: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 778px'
  },
  flex1: {
    display: 'flex'
  },
  flex1_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_spacer: {
    flex: '1 10 595px'
  },
  flex_item1: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 567px'
  },
  flex_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: 0
  },
  flex_spacer1: {
    flex: '1 1 164px'
  },
  hero_title: {
    overflow: 'visible',
    marginTop: 0,
    marginBottom: 0,
    margin: 0,
    font: '50px/1.5 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    whiteSpace: 'pre-wrap',
    '@media (max-width: 1199.98px)': {
      fontSize: '46px',
      textAlign: 'left'
    },
    '@media (max-width: 991.98px)': {
      fontSize: '36px'
    },
    '@media (max-width: 767.98px)': {
      fontSize: '39px'
    },
    '@media (max-width: 575.98px)': {
      fontSize: '28px'
    }
  },
  hero_title_box: {
    '@media (max-width: 1199.98px)': {
      alignItems: 'flex-start',
      justifyContent: 'flex-start'
    },
    '@media (max-width: 991.98px)': {
      alignItems: 'flex-start',
      justifyContent: 'flex-start'
    },
    '@media (max-width: 767.98px)': {
      alignItems: 'flex-start',
      justifyContent: 'flex-start'
    },
    '@media (max-width: 575.98px)': {
      alignItems: 'flex-start',
      justifyContent: 'flex-start'
    }
  },
  hero_title_box_layout: {
    flex: '0 0 auto',
    margin: '-36px 0px 0px 1px'
  },
  flex_spacer2: {
    flex: '1 1 40px'
  },
  highlights: {
    overflow: 'visible',
    marginTop: 0,
    marginBottom: 0,
    margin: 0,
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    whiteSpace: 'pre-wrap',
    '@media (max-width: 575.98px)': {
      fontSize: '13px',
      textAlign: 'left'
    }
  },
  highlights_box: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 575.98px)': {
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  },
  highlights_box_layout: {
    flex: '0 0 auto'
  },
  flex_item2: {
    display: 'flex',
    position: 'relative',
    flex: '0 0 auto'
  },
  group3: {
    display: 'flex',
    backgroundColor: 'rgb(204,84,57)',
    borderRadius: '0px 0px 0px 0px',
    width: '100%',
    height: '100%'
  },
  highlights1: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights1_layout: {
    width: 'fit-content',
    margin: '8px auto'
  },
  group4: {
    display: 'flex'
  },
  group4_layout: {
    position: 'relative',
    flex: '0 0 auto',
    margin: '40px 0px 0px',
    '@media (max-width: 99999px)': {
      display: 'flex'
    },
    '@media (max-width: 991.98px)': {
      display: 'none'
    }
  },
  flex2: {
    display: 'flex'
  },
  flex2_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 1px',
    '@media (max-width: 991.98px)': {
      display: 'flex'
    },
    '@media (max-width: 767.98px)': {
      display: 'none'
    }
  },
  flex_item3: {
    display: 'flex',
    position: 'relative',
    flex: '0 0 auto',
    minWidth: 100
  },
  icon: {
    background: 'var(--src) center center / contain no-repeat'
  },
  icon_layout: {
    height: 100,
    width: 100,
    minWidth: 100,
    margin: '0px 0px 6px'
  },
  flex_spacer3: {
    flex: '0 1 24px'
  },
  flex_item4: {
    display: 'flex',
    position: 'relative',
    flex: '1 0 auto',
    minWidth: 181.5
  },
  highlights2: {
    overflow: 'visible',
    marginTop: 0,
    marginBottom: 0,
    margin: 0,
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    letterSpacing: '0px',
    whiteSpace: 'pre-wrap'
  },
  highlights2_box: {},
  highlights2_box_layout: {
    flexGrow: 1,
    margin: '50px 0.5px 0px 0px'
  },
  flex_spacer4: {
    flex: '0 2 259.5px'
  },
  flex_spacer5: {
    flex: '1 1 50px'
  },
  group5: {
    display: 'flex'
  },
  group5_layout: {
    position: 'relative',
    flex: '0 0 auto',
    height: 30
  },
  group6: {
    display: 'flex'
  },
  group6_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 76px 0px 1px',
    '@media (max-width: 767.98px)': {
      margin: '0px 0px 0px 1px'
    }
  },
  component_layout1: {
    flexGrow: 1,
    '@media (max-width: 575.98px)': {
      margin: 0
    }
  },
  flex_spacer6: {
    flex: '1 1.5 50px'
  },
  group7: {
    display: 'flex'
  },
  group7_layout: {
    position: 'relative',
    flex: '0 0 auto'
  },
  component_layout2: {
    width: '95.52%',
    minWidth: 'min-content',
    margin: '0px auto',
    '@media (max-width: 991.98px)': {
      width: '97.71%'
    },
    '@media (max-width: 767.98px)': {
      width: '98.23%'
    }
  },
  flex_spacer7: {
    flex: '1 1.5 50px'
  },
  text_body: {
    display: 'flex',
    justifyContent: 'center',
    font: '14px/1.57 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  text_body_layout: {
    flex: '0 0 auto',
    width: '99.83%',
    minWidth: 'min-content',
    margin: '0px auto',
    '@media (max-width: 1399.98px)': {
      width: '100%'
    }
  }
});
